// extracted by mini-css-extract-plugin
module.exports = {"teaserList":"search-results_teaserList__Rv8aE","mobileGrid":"search-results_mobileGrid__OBODf"};